import SharedHelper from '@/Helpers/Shared';
export default {
  mixins: [SharedHelper],
  data() {
    return {};
  },
  methods: {
    getAllMissionNoteFunction: function (missionId, missionPhoneId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getAllMissionNoteFor115Mission', {
          missionId: missionId,
          missionPhoneId: missionPhoneId,
        })
        .then(() => {
          if (this.$store.state.missionNoteModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            let temp = this.$store.state.missionNoteModule.allMissionNote;
            if (this.tab === 'five') {
              // ماموریت 115 توضیحات
              this.readyNoteData(temp);
            }
            if (this.editTab === 'note') {
              //جزئیات ماموریت 800 توضیحات
              this.readyNoteData(temp);
            }
            if (this.$route.name === 'admissionMissions') {
              this.readyNoteData(temp);
            }
            if (this.$route.name === 'doctorMissions') {
              //doctor
              this.transformMissionDescription(temp);
              this.readyNoteData(temp);
            }
            if (this.$route.name === 'dashboardFollowUp') {
              //followUp
              this.readyNoteData(temp);
            }
            if (this.$route.name === 'missionReport') {
              //followUp
              this.readyNoteData(temp);
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.missionNoteModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getAllMissionNoteFunction(missionId, missionPhoneId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.missionNoteModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getAllMissionNoteFunction(missionId, missionPhoneId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    addNoteToMissionFucntion: function (note, missionId, missionPhoneId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      if (missionPhoneId) {
        missionPhoneId = Number(missionPhoneId);
      }
      let data = {
        note: note,
        missionPhoneId: missionPhoneId,
        missionId: Number(missionId),
      };
      this.$store
        .dispatch('addMissionNote', data)
        .then(() => {
          if (this.$store.state.missionNoteModule.successFlag) {
            if (this.disabelNoteConfirm) this.disabelNoteConfirm = false;
            this.showSuccessAlert('توضیحات جدید اضافه شد');
            this.noteText = '';
            this.getAllMissionNoteFunction(missionId, missionPhoneId);
          } else {
            this.disabelNoteConfirm = false;
            if (this.$store.state.missionNoteModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.addNoteToMissionFucntion(note, missionId, missionPhoneId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.missionNoteModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.addNoteToMissionFucntion(note, missionId, missionPhoneId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          this.load.val = false;
        });
    },
    showError: function () {
      this.snackText = this.$store.state.missionNoteModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
